import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';
import { RequestInstallerAssignmentFormComponent } from '../request-installer-assignment-form/request-installer-assignment-form.component';
import type { RequestInstallerAssignmentInitialValue } from '../request-installer-assignment-form/request-installer-assignment-form.types';
import { RequestInstallerAssignmentDialogData } from './request-installer-assignment-dialog.types';

@Component({
  selector: 'x-request-installer-assignment-dialog',
  imports: [RequestInstallerAssignmentFormComponent],
  templateUrl: './request-installer-assignment-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestInstallerAssignmentDialogComponent {
  protected readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<
    boolean,
    RequestInstallerAssignmentDialogData
  >;
  protected readonly request = this.context.data.request;
  protected readonly initialAssignment: RequestInstallerAssignmentInitialValue =
    {
      contractorCounterparty: this.request.contractorCounterpartyId,
      contractorSubdivision: this.request.contractorCounterpartySubdivisionId,
      installZone: this.request.installZoneId,
      // Контрол специалиста хранит персону (как и элементы xAttachInstallers), а не Installer
      installer: this.request.installerId ?? null,
    };

  protected closeUpdated(): void {
    this.context.completeWith(true);
  }

  protected cancel(): void {
    this.context.completeWith(false);
  }
}
